<!-- =========================================================================================
  File Name: Versement Banque view
  Description: view of versement banque
  ----------------------------------------------------------------------------------------
  Author: Eudoxie Djetouan
  Author Email: eudoxiedjetouan@gmail.com
========================================================================================== -->


<template>
  <div id="page-personnel-edit">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Liste Assurance" icon-pack="feather" icon="icon-users">
            <div class="tab-text">
              <versement-banq-list-tab></versement-banq-list-tab>
            </div>
          </vs-tab>
          <vs-tab label="Nouveau" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <versement-banq-add-tab></versement-banq-add-tab>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VersementBanqAddTab from './versement_banque_add.vue'
import VersementBanqListTab from './versement_banque_list.vue'
export default {
  name: 'VersementBanqueView',
  components: {
    VersementBanqAddTab,
    VersementBanqListTab
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>

<style scoped>

</style>
